import { Radio, TrendingUp, Bell, Eye, Search } from "lucide-react";

const STEPS = [
  { t: "09:12", label: "Erste Erwähnung", desc: "Eine öffentliche Quelle berichtet.", Icon: Radio },
  { t: "09:27", label: "Neue Entwicklung", desc: "Weitere Informationen und Quellen kommen hinzu.", Icon: TrendingUp },
  { t: "09:31", label: "NEWZER erkennt ein Signal", desc: "Die Entwicklung gewinnt an Bedeutung.", Icon: Eye },
  { t: "09:32", label: "Sie werden informiert", desc: "E-Mail · SMS · Webhook", Icon: Bell },
];

const COMPARE = [
  ["Trefferliste", "Lagebild"],
  ["Fundzeit", "Veröffentlichungszeit"],
  ["Einzelne Meldung", "Entwicklung"],
  ["Viele Benachrichtigungen", "Relevante Warnung"],
];

export default function ProductStory() {
  return (
    <>
      {/* 2B-1: Was passiert, wenn etwas wichtig wird? */}
      <section className="border-b border-fc-border bg-white" data-testid="product-story-timeline">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10 py-16 lg:py-20">
          <div className="max-w-2xl">
            <span className="text-xs font-bold uppercase tracking-wider text-fc-blue">Beobachten → Erkennen → Einordnen → Warnen</span>
            <h2 className="mt-3 font-head font-extrabold text-3xl lg:text-4xl text-fc-ink tracking-tight">Was passiert, wenn etwas wichtig wird?</h2>
          </div>
          <div className="mt-10 grid gap-4 md:grid-cols-4">
            {STEPS.map((s, i) => (
              <div key={s.t} className="relative rounded-2xl border border-fc-border bg-fc-ivory p-5" data-testid={`story-step-${i + 1}`}>
                <div className="flex items-center gap-2">
                  <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-fc-blue/10 text-fc-blue"><s.Icon className="w-4.5 h-4.5" strokeWidth={2} /></span>
                  <span className="font-mono text-sm font-bold text-fc-ink/50">{s.t}</span>
                </div>
                <div className="mt-3 font-head font-bold text-fc-ink leading-tight">{s.label}</div>
                <p className="mt-1 text-sm text-fc-ink/60 leading-relaxed">{s.desc}</p>
                {i < STEPS.length - 1 && <span className="hidden md:block absolute -right-3 top-1/2 -translate-y-1/2 text-fc-border text-2xl" aria-hidden>→</span>}
              </div>
            ))}
          </div>
          <p className="mt-5 text-xs text-fc-ink/40" data-testid="story-example-note">Produktbeispiel · keine Live-Daten. Reaktionszeiten hängen von Quelle und Veröffentlichung ab.</p>
          <p className="mt-6 max-w-3xl text-base text-fc-ink/70 leading-relaxed">
            Aus einzelnen Erwähnungen wird eine Entwicklung. Aus einer relevanten Entwicklung kann ein Signal werden.
            NEWZER behält diese Entwicklung für Sie im Blick.
          </p>
        </div>
      </section>

      {/* 2B-2: Mehr als eine Trefferliste */}
      <section className="border-b border-fc-border bg-fc-ivory" data-testid="product-story-compare">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10 py-16 lg:py-20">
          <h2 className="font-head font-extrabold text-3xl lg:text-4xl text-fc-ink tracking-tight">Mehr als eine Trefferliste.</h2>
          <div className="mt-10 grid gap-5 md:grid-cols-2">
            <div className="rounded-2xl border border-fc-border bg-white p-6" data-testid="compare-alert">
              <div className="flex items-center gap-2 text-fc-ink/50 text-sm font-semibold"><Search className="w-4 h-4" /> Klassischer Alert</div>
              <ol className="mt-4 space-y-2 text-sm text-fc-ink/70">
                <li>Treffer gefunden</li>
                <li>Link versendet</li>
                <li>selbst prüfen</li>
                <li>selbst bewerten</li>
              </ol>
            </div>
            <div className="rounded-2xl border-2 border-fc-blue bg-white p-6 shadow-[0_8px_30px_-12px_rgba(19,36,58,0.18)]" data-testid="compare-newzer">
              <div className="flex items-center gap-2 text-fc-blue text-sm font-bold"><Radio className="w-4 h-4" /> NEWZER</div>
              <ol className="mt-4 space-y-2 text-sm text-fc-ink">
                <li>beobachtet kontinuierlich</li>
                <li>erkennt Entwicklungen</li>
                <li>ordnet Informationen ein</li>
                <li>erkennt Signale</li>
                <li>alarmiert bei relevanten Veränderungen</li>
              </ol>
            </div>
          </div>
          <div className="mt-6 grid gap-2 sm:grid-cols-2">
            {COMPARE.map(([a, b]) => (
              <div key={a} className="flex items-center gap-3 rounded-xl bg-white border border-fc-border px-4 py-3 text-sm" data-testid="compare-pair">
                <span className="text-fc-ink/45">{a}</span>
                <span className="text-fc-border">↔</span>
                <span className="font-semibold text-fc-ink">{b}</span>
              </div>
            ))}
          </div>
          <p className="mt-8 font-head font-extrabold text-2xl text-fc-ink" data-testid="story-claim">Sie suchen nicht. NEWZER beobachtet.</p>
        </div>
      </section>
    </>
  );
}
